// extracted by mini-css-extract-plugin
export default {"setting_header_container":"SettingsHeader_setting_header_container__q6O1w","setting_main_content_container":"SettingsHeader_setting_main_content_container__IHwQU"};